var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapabilityLivePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 500,
    viewBox: "0 0 1000 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 500,
    fill: "#1b1f27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 470,
    height: 400,
    rx: 8,
    fill: "#232834"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 100,
    height: 20,
    fill: "#ffffff",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 430,
    height: 320,
    fill: "#ffffff",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 150,
    height: 20,
    fill: "#334155",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 390,
    height: 10,
    fill: "#cbd5e1",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 160,
    width: 390,
    height: 10,
    fill: "#cbd5e1",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 20,
    width: 470,
    height: 400,
    rx: 8,
    fill: "#232834"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 40,
    width: 120,
    height: 20,
    fill: "#ffffff",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 80,
    width: 430,
    height: 320,
    fill: "#ffffff",
    rx: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 100,
    width: 150,
    height: 20,
    fill: "#334155",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 140,
    width: 390,
    height: 10,
    fill: "#cbd5e1",
    rx: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 160,
    width: 390,
    height: 10,
    fill: "#cbd5e1",
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapabilityLivePreview);
export default __webpack_public_path__ + "static/media/capability-live-preview.be2edb4d46918e36878db3e38477e41c.svg";
export { ForwardRef as ReactComponent };